import React from 'react';
import PropTypes from 'prop-types';

import { CategoryGamesProvider, useCasinoNewState } from '@atlas/core';

import { ProvidersFilterBlock } from 'components/Pages/Casino/ProvidersFilterBlock';

const LobbyProvidersBlock = ({ blockTitleKey, imageUrl, onProviderClick }) => {
  const { group } = useCasinoNewState();

  return (
    <div className="casino-lobby__item">
      <CategoryGamesProvider gamesCount={20} group={group}>
        <ProvidersFilterBlock
          blockTitleKey={blockTitleKey}
          imageUrl={imageUrl}
          onProviderClick={onProviderClick}
        />
      </CategoryGamesProvider>
    </div>
  );
};

LobbyProvidersBlock.propTypes = {
  blockTitleKey: PropTypes.string,
  imageUrl: PropTypes.string,
  onProviderClick: PropTypes.func,
};

export default LobbyProvidersBlock;
